"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupPOD_LIFECYCLE = void 0;

var validator_id_1 = require("../../../validator-id");

var categories_1 = require("../../categories");

function setupPOD_LIFECYCLE(builder) {
  builder.validator(validator_id_1.ValidatorID.POD_LIFECYCLE).category(categories_1.ValidatorCategory.Compute).subCategory(categories_1.ValidatorSubCategory.Status).title('Pod Lifecycle Issues').description("Kubevious can detect varies issues during the Pod lifecycle such as \nOOMKills, CrashLoopBackOffs, etc and raise corresponding alerts.\n").affected('Pod').externalLink('https://kubernetes.io/docs/concepts/workloads/pods/pod-lifecycle/');
}

exports.setupPOD_LIFECYCLE = setupPOD_LIFECYCLE;